import React, { useState, useEffect } from "react";
import useHttp from '../hook/use-http';
import { API_URL_MAIN } from '../constants/driveglobalfilterinitalstates';
import { decodeToken } from "react-jwt";
import keycloak from '../keycloak'
import { specialAccessCheck } from "../services/Auth/specialAccessServices";

const AppContext = React.createContext({
    username: "",
    login_user: (userobj) => { },
    logout_user: () => { },
})

export const AppConextProvider = (props) => {
    const userloggedin = sessionStorage.getItem("user");
    const [username, setUsername] = useState(userloggedin);
    const [specialAccess, setSpecialAccess] = useState({
        landing_page_guidebook: false
    })
    const [error_, setLoginError] = useState({});
    const { isLoading, error, sendReq: fetchData } = useHttp();
    let ev_bus = '';

    useEffect(() => {
        if (sessionStorage.getItem("user") != "" && sessionStorage.getItem("user") != null) {
            const token = JSON.parse(sessionStorage.user);
            let myDecodedToken = decodeToken(token.token);
            ev_bus = myDecodedToken?.ev_bus;
        }
    }, [])

    function setSpecialUsersAccess(obj) {
        specialAccessCheck(obj).then((res) => {
           let gratedAccess= res?.reduce((acc, key) => {
                acc[key] = true;
                return acc;
            }, {});
            setSpecialAccess(prev=>({...prev, ...gratedAccess}))
        })
        .catch(() => {})
    }

    function login_user(userobj) {
        setUsername(userobj.username);
        sessionStorage.setItem("user", JSON.stringify(userobj));
        localStorage.setItem("user", JSON.stringify(userobj));
    }

    const appylogoutData = data => {
        localStorage.setItem('kc_logout_in_progress', 'true')
        sessionStorage.clear()
        sessionStorage.removeItem("user");
        setUsername("");
        keycloak.logout({
            redirectUri: window.location.origin
        })
    }

    function logout_user() {
        try {
            fetchData({ url: API_URL_MAIN + "auth/logout", body: { log: "logout", ev_bus: ev_bus } }, appylogoutData);
        } catch (err) {
            setLoginError(err);
        }
    }


    const redirectUserData = (data) => {
        sessionStorage.removeItem("user");
        setUsername("");
    }

    function redirectUserToVehicleList() {
        try {
            fetchData({ url: API_URL_MAIN + "auth/logout", body: { log: "logout", ev_bus: ev_bus } }, redirectUserData);
        } catch (err) {
            setLoginError(err);
        }
        sessionStorage.removeItem("user");
        setUsername("");
    }

    return <AppContext.Provider value={{ username, login_user, logout_user, redirectUserToVehicleList, specialAccess, setSpecialUsersAccess }}>{props.children}</AppContext.Provider>;
}

export default AppContext;
